<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import HkxxcxBrowse from "./HkxxcxBrowse";
import HkxxcxForm from "./HkxxcxForm";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters, mapActions } = createNamespacedHelpers("user");
export default {
    name: "Hkxxcx",
    components: { HkxxcxBrowse, HkxxcxForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showForm: false
            }
        };
    },
    created() {
        if (this.getNoticeId) {
            this.editProps.dataId = this.getNoticeId;
            this.setNoticeId(null);
            this.editProps.showForm = true;
        }
    },
    computed: {
        ...userMapGetters(["getNoticeId"]),
        compName() {
            if (this.editProps.showForm === true) {
                return "HkxxcxForm";
            } else {
                return "HkxxcxBrowse";
            }
        }
    },
    methods: {
        ...mapActions(["setNoticeId"])
    }
};
</script>
